<template>
  <el-dialog
    title="Raktárközi megrendelés létrehozása"
    :visible="true"
    width="600px"
    @close="handleClose"
    :close-on-click-modal="false"
  >
    <el-form
      ref="representativeOrderForm"
      :model="formData"
      :rules="rules"
      label-position="top"
      v-loading="loading"
      @submit.native.prevent="save"
    >
      <el-form-item
        prop="target_storage_id"
        label="Cél raktár"
      >
        <el-select
          v-model="formData.target_storage_id"
          filterable
          placeholder="Válassz raktárat"
          style="width: 100%;"
        >
          <el-option
            v-for="storage in storages"
            :label="storage.name"
            :value="storage.id"
            :key="storage.id"
          />
        </el-select>
      </el-form-item>
    </el-form>
    <div
      slot="footer"
      class="dialog-footer"
    >
      <el-button @click="handleClose">
        Mégse
      </el-button>
      <el-button
        type="primary"
        @click="save"
        :loading="buttonLoading"
      >
        Mentés
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  props: {
    inwardHandlingId: {
      type: Number,
      default: null
    }
  },
  data() {
    return {
      loading: false,
      buttonLoading: false,
      storages: [],
      formData: {
        target_storage_id: null
      },
      rules: {
        target_storage_id: [
          { required: true, message: 'Cél raktár kiválasztása kötelező', trigger: 'change' }
        ]
      }
    };
  },
  methods: {
    handleClose() {
      this.$emit('close');
    },
    async save() {
      try {
        await this.$refs.representativeOrderForm.validate();

        this.buttonLoading = true;

        await this.$store.dispatch('inwardHandling/createRepresentativeOrder', {
          inwardHandlingId: this.inwardHandlingId,
          target_storage_id: this.formData.target_storage_id,
        });

        this.handleClose();

      } catch (e) {
        if (e.response && e.response.data && e.response.data.message) {
          this.$message.error(e.response.data.message);
        } else if (e.message) {
          this.$message.error(e.message);
        }
      } finally {
        this.buttonLoading = false;
      }
    }
  },
  async mounted() {
    this.storages = await axios.get('api/storage-list');
  }
};
</script>
